import { createFeature, createReducer, on } from '@ngrx/store';
import { Crypto } from '../entities/crypto.model';
import { ETPListItem } from '../entities/etp.model';
import { cryptoActions, cryptoApiActions } from './crypto.actions';

type LoadingState = 'LOADING' | 'LOADED' | 'INITIAL';

export interface CryptoState {
  cryptos: Crypto[];
  cryptoIsins: string[];
  cryptosLoadingState: LoadingState;
  etps: ETPListItem[];
  etpIsins: string[];
  etpsLoadingState: LoadingState;
}

export const initialState: CryptoState = {
  cryptos: [],
  cryptoIsins: [],
  cryptosLoadingState: 'INITIAL',
  etps: [],
  etpIsins: [],
  etpsLoadingState: 'INITIAL',
};

export const cryptoFeature = createFeature({
  name: 'crypto',
  reducer: createReducer(
    initialState,
    on(
      cryptoApiActions.loadCryptosFromApi,
      (state): CryptoState => ({
        ...state,
        cryptosLoadingState: 'LOADING',
      }),
    ),
    on(
      cryptoApiActions.loadCryptosSuccess,
      (state, { cryptos }): CryptoState => ({
        ...state,
        cryptos,
        cryptoIsins: cryptos.map((crypto) => crypto.isin),
        cryptosLoadingState: 'LOADED',
      }),
    ),
    on(cryptoApiActions.loadCryptosFailure, (state): CryptoState => ({ ...state, cryptosLoadingState: 'INITIAL' })),
    on(
      cryptoApiActions.loadETPsFromApi,
      (state): CryptoState => ({
        ...state,
        etpsLoadingState: 'LOADING',
      }),
    ),
    on(
      cryptoApiActions.loadETPsSuccess,
      (state, { etps }): CryptoState => ({
        ...state,
        etps,
        etpIsins: etps.flatMap((etp) => etp.etps).map((etp) => etp.isin),
        etpsLoadingState: 'LOADED',
      }),
    ),
    on(cryptoApiActions.loadETPsFailure, (state): CryptoState => ({ ...state, etpsLoadingState: 'INITIAL' })),
    on(
      cryptoActions.updateCryptos,
      (state, { cryptos }): CryptoState => ({
        ...state,
        cryptos,
      }),
    ),
    on(
      cryptoActions.updateETPs,
      (state, { etps }): CryptoState => ({
        ...state,
        etps,
      }),
    ),
  ),
});
